import { formatDate } from "@medere/medere-ui-framework";
import { Button } from "primereact/button";
import { useNavigate } from "react-router";
import { StudiesInformDetailsDTO } from "../../../dto/StudiesInformListItemDTO";

interface StudiesInformCardProps {
  study: StudiesInformDetailsDTO;
  position: number;
}

export function StudiesInformCard({ study, position }: StudiesInformCardProps) {
  const navigate = useNavigate()
  const isLaboratory = study.studyTypeLabel?.trim().toLowerCase() === 'laboratorio'
  return (
    <>
      {position === 0 ? (
        <div className="study-inform-card mb-3">
          <div className="flex align-items-center gap-3">
            <div className="flex-1">
              <div className="study-inform-card-header">
                <span className="studies-inform-section-title">Paciente</span>
              </div>
              <div className="study-inform-card-row">
                <span className="font-semibold">{study.patientFullName}</span>
                {study.age && (
                  <span className="font-semibold"> | {study.age} años</span>
                )}
                {study.phonenumber && (
                  <span className="text-color-secondary"> | Cel: {study.phonenumber}</span>
                )}
                {study.email && (
                  <span className="text-color-secondary"> | Mail: {study.email}</span>
                )}
              </div>
              <div className="study-inform-card-row text-color-secondary">
                {study.healthEntityName && (
                  <span> {study.healthEntityName}</span>
                )}
                {study.coverage && (
                  <span> | Plan: {study.coverage}</span>
                )}
                {study.benefitnumber && (
                  <span> | Nro. afiliado: {study.benefitnumber}</span>
                )}
              </div>
            </div>
          </div>
        </div>
      ) : (
        <div className="study-inform-card mb-3">
          <div className="flex align-items-center gap-3">
            <div className="flex-1">
              <div className="study-inform-card-header">
                <span className="studies-inform-section-title">Datos del estudio</span>
              </div>
              <div className="study-inform-card-row">
                {study.studyTypeLabel && (
                  <span className="font-semibold">{study.studyTypeLabel}</span>
                )}
                {study.professionalFullName && (
                  <span className="text-color-secondary">
                    {' '}| Solicitado por <strong>{study.professionalFullName}</strong>
                  </span>
                )}
                {study.requestedDate && (
                  <span className="text-color-secondary">
                    {' '}| Fecha <span className="font-semibold">{formatDate(study.requestedDate)}</span>
                  </span>
                )}
              </div>
              {study.presumptiveDiagnostic && (
                <div className="study-inform-card-row text-color-secondary">
                  Diagnóstico presuntivo: {study.presumptiveDiagnostic}
                </div>
              )}
              {study.observations && (
                <div className="study-inform-card-row text-color-secondary">
                  Observaciones: {study.observations}
                </div>
              )}
            </div>
            {!isLaboratory && study.requiresImages && (
              <Button
                label="Acceso DICOM"
                className="study-inform-dicom-btn"
                outlined
                size="small"
                disabled={!study.dicomViewerUrl}
                onClick={() => study.dicomViewerUrl && window.open(study.dicomViewerUrl, '_blank')}
              />
            )}
          </div>
        </div>
      )}
    </>
  );
}